var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":"top","content":"點擊複製"}},[_c('div',{ref:"slot",staticClass:"clipboard",on:{"click":_vm.copy}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }